import { render, staticRenderFns } from "./VxActionIcon.vue?vue&type=template&id=82c13bf6&scoped=true"
import script from "./VxActionIcon.vue?vue&type=script&lang=js"
export * from "./VxActionIcon.vue?vue&type=script&lang=js"
import style0 from "./VxActionIcon.vue?vue&type=style&index=0&id=82c13bf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c13bf6",
  null
  
)

export default component.exports